import gql from "graphql-tag";

import { Fragment, Report } from "../types";
import { ReportAnswerFragment, REPORT_ANSWER_FRAGMENT } from "./ReportAnswer";
import {
  ReportReferentFragment,
  REPORT_REFERENT_FRAGMENT,
} from "./ReportReferent";

export const MAD_REPORT_FRAGMENT = gql`
  fragment MadReportFragment on Report {
    id
    type
    createdAt
    filledAt
    checkedAt
    docusignEnvelopeStatus
  }
`;

export type MadReportFragment = Fragment<
  Report,
  Pick<
    Report,
    | "id"
    | "type"
    | "createdAt"
    | "filledAt"
    | "checkedAt"
    | "docusignEnvelopeStatus"
  >
>;

export const MAD_REPORT_FULL_FRAGMENT = gql`
  fragment MadReportFullFragment on Report {
    id
    type
    createdAt
    filledAt
    checkedAt
    docusignEnvelopeStatus

    reportReferents {
      ...ReportReferentFragment
    }
    reportAnswers {
      ...ReportAnswerFragment
    }
  }

  ${REPORT_REFERENT_FRAGMENT}
  ${REPORT_ANSWER_FRAGMENT}
`;

// prettier-ignore
export type MadReportFullFragment = Fragment<
  Report,
  Pick<Report, "id" | "type" | "createdAt" | "filledAt" | "checkedAt" | "docusignEnvelopeStatus"> & {
    reportAnswers: ReportAnswerFragment[];
    reportReferents: ReportReferentFragment[];
  }
>;
